/**
 * Wait for the browser to finish layout after a modal closes (avoids ResizeObserver loops).
 */
export function flushLayoutFrame() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
}

/**
 * Navigate after layout teardown so route changes don't fight modal close.
 */
export async function navigateAfterCelebration(navigate, path, options) {
  await flushLayoutFrame();
  navigate(path, options);
}
